export default __webpack_public_path__ + "static/media/ZKZg.90672f1d.gif";